import debounce from 'lodash.debounce';
import { Options } from 'vue-class-component';
import CommandWizardStep from '../CommandWizardStep';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { NamingService } from '@/core/services/naming.service';
import { RoomObjectType } from '@/../client-generator/generated-clients/plants';
import { PlantEntityType } from '@/../client-generator/generated-clients/configurations';
import { NAME_VALIDATION_DEBOUNCE_TIME } from '@/core/utils/utils';

@Options({
  name: 'CommandWizardStep1',
  emits: ['next-enabled'],
  watch: {
    'commandGroup.roomObjectType': function () {
      if (!this.isEditMode()) this.computeGroupName();
    },
    'commandGroup.name': function () {
      this.verifyValidityOfName();
    },
  },
})
export default class CommandWizardStep1 extends CommandWizardStep {
  isValidName = true;
  initialName!: string;
  invalidNameReason: string = '';
  RoomObjectType = RoomObjectType;

  async mounted() {
    if (this.commandGroup.roomObjectType === RoomObjectType.None) {
      this.commandGroup.roomObjectType = RoomObjectType.Light;
    }

    if (this.isEditMode()) {
      this.initialName = this.commandGroup.name ?? '';
    }

    this.verifyValidityOfName = debounce(
      this.verifyValidityOfName,
      NAME_VALIDATION_DEBOUNCE_TIME
    );

    NamingService.flushCache();
    await NamingService.prefetchFlatEntities(
      this.plantId,
      PlantEntityType.GROUP
    );
  }

  private async verifyValidityOfName() {
    this.$store.dispatch(SET_APP_LOADING, true);
    const validName = NamingService.isValidEntityTypeName(
      this.commandGroup.name
    );

    if (this.initialName !== this.commandGroup.name && !validName) {
      const suggestedName = await NamingService.suggestNextValidEntityName({
        eType: PlantEntityType.GROUP,
        plantId: this.plantId,
        metadata: {
          roomObjectType: this.commandGroup.roomObjectType,
        },
      });
      this.isValidName = validName;
      this.invalidNameReason = this.$t(
        `uniqueNaming.validationErrorWithSuggestion`,
        { suggestedName }
      );
      this.$emit('next-enabled', false);
    } else {
      this.isValidName = true;
      this.invalidNameReason = '';
      this.$emit('next-enabled', true);
    }
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  private isEditMode(): boolean {
    return !!this.commandGroup.id && !!this.commandGroup.id.trim().length;
  }

  // DO NOT DELETE ME: I'm used in the watcher
  private async computeGroupName() {
    this.$store.dispatch(SET_APP_LOADING, true);
    this.commandGroup.name = await NamingService.suggestNextValidEntityName({
      eType: PlantEntityType.GROUP,
      plantId: this.plantId,
      metadata: {
        roomObjectType: this.commandGroup.roomObjectType,
      },
    });
    this.$store.dispatch(SET_APP_LOADING, false);
  }
}
